export default __webpack_public_path__ + "static/media/cp_geo_ps.3a0dc2f0.svg";